import styled from 'styled-components';
import { CheckoutPersonalDetailsStyled } from '../CheckoutPersonalDetailsStyled';

export const CheckoutPersonalDetailsStyledAC = styled(CheckoutPersonalDetailsStyled)``;
